import { render, staticRenderFns } from "./Vagas_Detalhe.vue?vue&type=template&id=370f19e0&scoped=true"
import script from "./Vagas_Detalhe.vue?vue&type=script&lang=js"
export * from "./Vagas_Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Vagas_Detalhe.vue?vue&type=style&index=0&id=370f19e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f19e0",
  null
  
)

export default component.exports